export default {
  RESELLER_INVOICES_LIST: "Liste des factures",
  ADD_RESELLER_INVOICE: "Ajouter une facture",
  ADD_RESELLER_INVOICE_ITEM: "Ajouter une ligne",
  RESELLER_INVOICE_ADDED: "Facture ajoutée",
  OWNER: "Propriétaire",
  EDIT_RESELLER_INVOICE: "Modifier une facture",
  RESELLER_INVOICE_UPDATED: "Facture mise à jour",
  BILLING_ADDRESS: "Adresse de facturation",
  EXPIRATION_TIME: "Date d'expiration",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Choisir un produit",
  SELECT_SUBSCRIPTIONS: "Choisir une inscription",
  SELECT_PACKAGES: "Choisir un forfait",
  DELETE_RESELLER_INVOICE_ITEM: "Supprimer la ligne",
  UPDATE_RESELLER_INVOICE_ITEM: "Modifier la ligne",
  RESELLER_INVOICE_ITEM_DELETED: "Ligne supprimée",
  RESELLER_INVOICE_ITEM_ADDED: "Ligne ajoutée",
  RESELLER_INVOICE_ITEM_EDITED: "Ligne modifiée",
  SEND: "Envoyer",
  CANCEL: "Annuler",
  REFUND: "Rembourser",
  ADD_PAYMENT: "Ajouter un paiement",
  RESELLER_INVOICE_SENT: "Facture envoyée",
  SELECT_USERS: "Choisir l'utilisateur",
  SELECT_CUSTOMERS: "Choisir le client",
  SELECT_ORGANIZATIONS: "Choisir l'organization",
  SELECT_SUPPLIERS: "Choisir le fournisseur",
  DELETE_THIS_RESELLER_INVOICE: "Supprimer cette facture ?",
  RESELLER_INVOICE_DELETED: "Facture supprimée",
  CANCEL_RESELLER_INVOICE_QUESTION: "Annuler la facture ?",
  RESELLER_INVOICE_CANCELED: "Facture annulée",
  RECIPIENT: "Destinataire",
  ISSUER: "Emetteur",
  VALIDATE: "Valider",
  RESELLER_INVOICE_VALIDATED: "Facture validée",
  VIEW_ORDER: "Voir la commande",
  SELECT_ORGANIZATION: "Choisir l'organisation",
  VIEW_RESELLER_INVOICE: "Facture",
};
